import React, { Component } from 'react';
import { Row, Column } from 'simple-flexbox';
import { Button, Panel } from "react-bootstrap";

import Alert from "@modules/Alert";
import Form from "@sm/core/Form";
import Select from "@modules/Select";
import Spinner from '@components/Spinner';

import { crudActions } from "@sm/services/crudActions";
import { addLogItem } from "@sm/utils/utils";

class WalletInfo extends Component {
  state = {
    currency: "",
    walletForm: new Form(),
    walletFormFields: [],
    isPendingChanges: false,
    showAlert: false,
    alertType: "success",
    alertMessage: "",
    isLoadingWallet: false,
    logs: []
  };

  componentDidMount() {
    const { otcCurrencies } = this.props;

    if (!otcCurrencies.length) return;

    this.onCurrencyChange(otcCurrencies[0], "currency");
  };

  onValueChange = (event, fieldName, formName) => {
    const { currency } = this.state;
    const form = this.state[formName];
    const prevValue = form[fieldName];
    let newValue = null;
    if (event.value) {
      newValue = event.value;
    } else if (event.target) {
      newValue = event.target.value;
    } else {
      newValue = event.map(elem => elem.value);
    }
    form[fieldName] = newValue;

    this.addLog(prevValue, newValue, fieldName, currency);

    this.setState({
      [formName]: form
    });
  };

  onCurrencyChange = (event, fieldName) => {
    this.setState({
      [fieldName]: event.value,
      logs: []
    }, () => {
      this.getWalletInfo();
    });
  };

  addLog = (valueBefore, valueAfter, field, currency) => {
    const { logs } = this.state;
    const { merchantId } = this.props;
  
    const type = "WALLET_UPDATE";
  
    const updatedLogs = addLogItem(logs, type, valueBefore, valueAfter, field, merchantId, currency);
  
    this.setState({
      logs: updatedLogs
    });
  
    this.setState({
      logs
    });
  };

  getWalletInfo = () => {
    const { merchantId } = this.props;
    const { currency } = this.state;

    this.setState({
      isLoadingWallet: true
    });

    crudActions.get(`v1/clients/wallet/${merchantId}?currency=${currency}&isAgent=false`)
      .then(response => {
        if (response) {
          const formFields = {};
          const formFieldRules = [];
          let isPendingChanges = false;
          response.walletInfoList?.forEach(field => {
            if (field.pendingValue) {
              isPendingChanges = true;
            }
            formFields[field.id] = field.value || "";
            formFieldRules.push({
              name: field.id,
              type: "isString",
              rules: {
                required: field.required || field.id !== "updatedDate",
                ...(field.minLength && { min: field.minLength }),
                ...(field.maxLength && { max: field.maxLength })
              }
            });
          });

          this.setState({
            walletForm: new Form(formFields, formFieldRules),
            walletFormFields: response.walletInfoList,
            isPendingChanges,
            isLoadingWallet: false
          });
        }
      })
      .catch(err => {
        if (err && err.message) {
          this.setState({
            showAlert: true,
            alertType: "error",
            alertMessage: err.message
          });
        }
      });
  };
  
  submitWalletInfo = (e) => {
    const { currency, logs, walletForm } = this.state;
    const { companyId, merchantId } = this.props;
    e.preventDefault();
    
    const isFormValid = walletForm.isFormValid();

    this.setState({
      walletForm
    });

    if (isFormValid) {
      this.setState({
        isLoadingWallet: true
      });
      const walletFormData = walletForm.data();
      delete walletFormData.updatedDate;

      const data = {
        companyId,
        id: merchantId,
        currency,
        isAgent: false,
        fields: walletFormData,
        changes: logs
      };
      crudActions.post(`v1/clients/wallet/update`, data)
        .then(() => {
          this.setState({
            showAlert: true,
            alertType: "info",
            alertMessage: "The Wallet Info has successfully been submitted.",
            isLoadingWallet: false
          }, () => {
            this.getWalletInfo();
          });
        })
        .catch(err => {
          if (err && err.message) {
            this.setState({
              showAlert: true,
              alertType: "error",
              alertMessage: err.message,
              isLoadingWallet: false
            });
          }
        });
    }
  };

  onConfirm = () => {
    this.setState({
      showAlert: false,
      alertType: "success",
      alertMessage: ""
    });
  };

  render() {
    const { loadingGeneralSettings, otcCurrencies } = this.props;
    const {
      alertMessage,
      alertType,
      currency,
      isLoadingWallet,
      isPendingChanges,
      showAlert,
      walletForm,
      walletFormFields
    } = this.state;

    const loader = (
      <div style={ { width: "100%", height: "200px", display: "flex", alignItems: "center", justifyContent: "center" } }>
        <Spinner smallContainer={ true } />
      </div>
    );
    
    return (
      <Panel>
        <Panel.Heading>
          <Panel.Title>
            WALLET INFO
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          {loadingGeneralSettings ? (
            <>{ loader }</>
          ) : (
            <>
              <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
                <Column flexGrow={ 0 } vertical='end' className="input-column">
                  <Select
                    id="currency"
                    name="currency"
                    value={ currency }
                    clearable={ false }
                    onChange={ (event) => this.onCurrencyChange(event, "currency") }
                    options={ otcCurrencies }
                  />
                </Column>
              </Row>
              <hr/>
              {isLoadingWallet ? (
                <>{ loader }</>
              ) : (
                <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
                  {walletFormFields?.map(field => (
                    <Column key={ field.id } flexGrow={ 0 } vertical='end' className="input-column">
                      <label htmlFor={ field.id }>{ field.label }</label>
                      <input
                        type="text"
                        id={ field.id }
                        name={ field.id }
                        autoComplete="on"
                        className={ 'form-control ' + (walletForm.errors.has(field.id) ? 'error-field' : '') }
                        disabled={ field.id === "updatedDate" || isPendingChanges }
                        value={ walletForm[field.id] }
                        onChange={ (event) => this.onValueChange(event, field.id, "walletForm") }
                      />
                      {walletForm.errors.has(field.id) && (
                        <span className="error-message">
                          {walletForm.errors.get(field.id)}
                        </span>
                      )}
                    </Column>
                  ))}
                </Row>
              )}
              {isPendingChanges && (
                <>
                  <hr/>
                  <h4>There are pending changes on { currency } wallet:</h4>
                  <ul className="list-unstyled">
                    {walletFormFields?.map(field => {
                      return field.pendingValue && (
                        <li key={ field.id }>
                          <h4><b>{field.label }:</b> { field.pendingValue }</h4>
                        </li>
                      );
                    })}
                  </ul>
                </>
              )}
              <Row flexGrow={ 1 } horizontal='end' wrap={ true } vertical='start'>
                <Column flexGrow={ 0 } vertical='end' className="input-column">
                  <Button
                    className="btn defaultBtn"
                    disabled={ isPendingChanges }
                    onClick={ (e) => this.submitWalletInfo(e) }
                  >
                    Save
                  </Button>
                </Column>
              </Row>
            </>
          )}

          {showAlert && (
            <Alert
              show={ showAlert }
              title={ alertType }
              type={ alertType }
              text={ alertMessage }
              confirmButtonColor="#187EED"
              onConfirm={ this.onConfirm }
            />
          )}
        </Panel.Body>
      </Panel>
    );
  }
}

export default WalletInfo;